<template>
  <v-container fluid class="pa-0">
    <v-card class="mr-3 ml-3 mb-3">
      <!--    <v-card-title class="headline">-->
      <!--      <span class="mr-3">Модули</span>-->
      <!--      <v-btn class="mr-3" color="green" dark to="/modules/add">-->
      <!--        <v-icon>mdi-plus</v-icon>-->
      <!--        Добавить-->
      <!--      </v-btn>-->
      <!--      <v-btn-->
      <!--          color="green"-->
      <!--          dark-->
      <!--          @click="showingDeleted = !showingDeleted"-->
      <!--      >-->
      <!--        <span v-if="!showingDeleted">Показать удаленные</span>-->
      <!--        <span v-else>Скрыть удаленные</span>-->
      <!--      </v-btn>-->
      <!--      <v-spacer></v-spacer>-->
      <!--      <v-text-field-->
      <!--          v-if="$store.getters.modules"-->
      <!--          v-model="search"-->
      <!--          append-icon="mdi-magnify"-->
      <!--          label="Поиск"-->
      <!--          single-line-->
      <!--          hide-details-->
      <!--      ></v-text-field>-->
      <!--    </v-card-title>-->
      <v-card-title class="headline justify-space-between">
        <div>
          <v-btn class="mr-3" color="green" dark to="/modules/add">
            <v-icon>mdi-plus</v-icon>
            Добавить
          </v-btn>
          <v-btn class="mr-3" color="green" dark @click="showingDeleted = !showingDeleted">
            <span v-if="!showingDeleted">Показать удаленные</span>
            <span v-else>Скрыть удаленные</span>
          </v-btn>
          <v-menu v-if="this.$store.getters.user.roleId === 0" class="mr-3" color="green" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on">
                <v-icon>mdi-file-download</v-icon>
                Выгрузить в файл
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="exportToFile('csv')">csv</v-list-item>
              <v-list-item @click="exportToFile('xlsx')">xlsx</v-list-item>
            </v-list>
          </v-menu>
        </div>

        <div>
          <v-text-field
            v-if="$store.getters.dealers"
            v-model="search"
            append-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
            class="pt-0"
          ></v-text-field>
        </div>
      </v-card-title>

      <v-data-table
        class="mb-3 mx-3"
        :search="search"
        :headers="headers"
        :items="modules"
        :item-class="
          (item) => (item.isDeleted ? 'deleted clickable-row' : 'clickable-row')
        "
        no-data-text="Пусто"
        no-results-text="Результатов нет"
        @click:row="editModule"
        hide-default-footer
        :loading="tableLoading"
        loading-text="Загрузка"
        :items-per-page="10"
      >
        <template v-slot:item.isPrivate="{ item }">
          <v-icon v-if="item.isPrivate">{{ "mdi-check" }}</v-icon>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-tooltip v-if="!item.isDeleted" top nudge-bottom="4">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                @click.stop="deleteModuleConfirm(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Удалить</span>
          </v-tooltip>

          <v-tooltip v-else top nudge-bottom="4">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                @click.stop="restoreModule(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-backup-restore
              </v-icon>
            </template>
            <span>Восстановить</span>
          </v-tooltip>
        </template>
        <template v-slot:top="{ pagination, options, updateOptions }">
          <v-data-footer
            :pagination="pagination"
            :options="options"
            @update:options="updateOptions"
            :items-per-page-options="[10, 50, 100, -1]"
            items-per-page-text="$vuetify.dataTable.itemsPerPageText"
          />
        </template>
        <template v-slot:item.updateTime="{ item }">
          <span>{{ formatUpdateTime(item.updateTime) }}</span>
        </template>
      </v-data-table>
    </v-card>

    <confirmation-dialog
      ref="confirmation"
      title="Удаление Модуля ПО"
      agree-button="Удалить"
      disagree-button="Отмена"
      @agree="deleteModule($event)"
    ></confirmation-dialog>
  </v-container>
</template>

<script>
import API from "@/axios/api";
import ConfirmationDialog from "@/components/ConfirmationDialog";

import FormatDateTime from "@/utils/time.js";

export default {
  components: {
    ConfirmationDialog,
  },
  data() {
    return {
      deletingModuleId: "",

      tableLoading: true,
      search: "",
      showingDeleted: false,
      headers: [
        {
          text: "#",
          align: "start",
          value: "id",
        },
        {
          text: "Название",
          align: "start",
          value: "name",
        },
        {
          text: "Доп. инфо",
          align: "start",
          value: "description",
          sortable: false,
        },
        {
          text: "Служебный",
          align: "center",
          value: "isPrivate",
          sortable: false,
        },
        {
          text: "Изменил",
          align: "start",
          value: "creatorName",
        },
        {
          text: "Дата последнего изменения",
          align: "start",
          value: "updateTime",
        },
        {
          text: "Действия",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    exportToFile(format) {
      const showingDeleted = this.showingDeleted;
      API.get(`modules/report?format=${format}&showingDeleted=${showingDeleted}`, { responseType: 'blob' })
      .then(response => {
      if (response.status === 200) {
        let contentType = '';
        let fileExtension = '';
        if (format === 'csv') {
          contentType = 'text/csv';
          fileExtension = '.csv';
        } else if (format === 'xlsx') {
          contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          fileExtension = '.xlsx';
        }
        const blob = new Blob([response.data], { type: contentType });
        const date = new Date();
        const currentDate = this.formatUpdateTime(date); 
        const filename = `Отчет модули ПО ${currentDate}${fileExtension}`.replace(/:/g, '.');
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
        }
        console.log('Файл успешно загружен');
      } else {
        console.error('Ошибка загрузки файла:', response.statusText);
      }
    })
    .catch(error => {
      console.error('Ошибка загрузки файла:', error);
    });
},
    editModule(module) {
      if (module.isDeleted) {
        this.$store.commit("showSnackbar", {
          color: "warning",
          text: "Модуль удален",
        });
      } else {
        this.$router.push("/modules/" + module.id);
      }
    },
    deleteModuleConfirm(module) {
      this.deletingModuleId = module.id;
      this.$refs.confirmation.showDialog(
        module.id,
        `Вы действительно хотите удалить Модуль <span class="highlighted">${module.name}</span> ?`
      );
    },
    deleteModule(moduleId) {
      API.get(`modules/${moduleId}/delete`)
        .then((response) => {
          console.log(response.data);
          this.$store.dispatch("updateModules");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    restoreModule(module) {
      API.get(`modules/${module.id}/restore`)
        .then((response) => {
          console.log(response.data);
          this.$store.dispatch("updateModules");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    formatUpdateTime(time) {
      return FormatDateTime(time);
    },
  },
  computed: {
    modules: function () {
      return this.$store.getters.modules.filter((module) =>
        this.showingDeleted ? true : !module.isDeleted
      );
    },
  },
  activated() {
    this.$store.commit("setCrumbs", [
      { text: "main", disabled: false, to: "/", exact: true },
      { text: "modules", disabled: true },
    ]);
  },
  created() {
    this.$store.dispatch("updateModules").then(() => {
      this.tableLoading = false;
    });
  },
};
</script>

<style>
.deleted {
  background-color: #e5d4d4;
}
</style>
